export const combineStyleArray = (extraStyle, styles) => {
  const hasMultiple = Array.isArray(extraStyle);
  const styling = hasMultiple
    ? extraStyle.map((style) => styles[style]).join(" ")
    : styles[extraStyle];
  return styling;
};
